import React from 'react'
import styled from '@emotion/styled'
import {NavLink} from 'react-router-dom'

import catalogTypes from '../Root/catalog-types'

const Root = styled.div`
  font: 15px/1.5 raleway, sans-serif;
  color: #444;
`

const TopMenuItem = styled.div`
  padding: 15px 5px 15px 1px;
  border-bottom: 1px solid #ddd;
`

const TopMenuLink = styled(NavLink)`
  display: block;
  border: none;
  font-weight: 600;
  color: inherit;
  
  &.active {
    color: #e61818;
  }
`

const SubMenu = styled.div`
  padding-top: 6px;
`

const SubMenuItem = styled(NavLink)`
  display: block;
  border: none;
  padding: 2px 0;
  text-decoration: none;
  color: inherit;
  font-size: 13px;
  font-weight: 400;
  
  padding-left: ${({nesteditem}) => nesteditem ? '17px' : 0};
  
  &.active {
    color: #e61818;
  }
`

const CatalogSidebar = ({activeCategory, activeCatalogType, categoriesByCatalogTypeNames}) => {
  const menuItems = Object.values(catalogTypes).map(catalogType => {
    let subMenu = null
    if (catalogType === activeCatalogType) {
      const subItems = categoriesByCatalogTypeNames[activeCatalogType.name].map(category =>
        (category.parentId === 206 || (activeCategory && (activeCategory.id === category.parentId || activeCategory.parentId === category.parentId)))
          && <SubMenuItem key={category.id} to={catalogType.getCategoryLink(category.id)} nesteditem={category.parentId !== 206 ? 1 : 0}>
          {category.title}
        </SubMenuItem>
      )

      subMenu = <SubMenu>{subItems}</SubMenu>
    }

    return <TopMenuItem key={catalogType.name}>
      <TopMenuLink to={catalogType.link} exact>{catalogType.title}</TopMenuLink>
      {subMenu}
    </TopMenuItem>
  })

  return <Root>
    {menuItems}
  </Root>
}

export default CatalogSidebar
